import * as moment from 'moment';

export interface IUnixTimestampFormatter {
  (input:number):moment.Moment;
}

export interface IMomentFormatter {
  (input:moment.Moment,
   formatType?:'overriddenDate-time'|'overriddenDate'|'time'|'month'|'month-long'|'roman'):string;
}

export default function MomentFormatter():IMomentFormatter {
  return (input:moment.Moment|Date, formatType?:string) => {
    if (!input) {
      return '∞';
    }
    input = moment(input);
    if (input && (moment.isMoment(input) || moment.isDate(input))) {
      const momentInput = moment(input);
      switch (formatType) {
        case 'overriddenDate-time':
          return momentInput.format('lll');
        case 'date':
          return momentInput.format('LL');
        case 'time':
          return momentInput.format('LT');
        case 'month':
          return momentInput.format('MMM YYYY');
        case 'month-long':
          return momentInput.format('MMMM YYYY');
        case 'year':
          return momentInput.format('YYYY');
        case 'roman':
          return momentInput.locale('en-roman-months').format('D.MMM');
        case 'day':
          return momentInput.format('Do, dddd');
        default:
          return momentInput.format('LL');
      }
    }
    return null;
  }
}

export function UnixTimestampFormatter():IUnixTimestampFormatter {
  return (input:number) => {
    if (input) {
      return moment.unix(input);
    }
    return null;
  }
}

moment.locale('en-roman-months', {
  monthsShort: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII',
    'VIII', 'IX', 'X', 'XI', 'XII'
  ]
});
moment.locale('en');



/** WEBPACK FOOTER **
 ** ./app/utils/moment.formatter.ts
 **/